import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Loader from '../shared/loader';
import Pagination from '../shared/pagination';
import Enum from '../../utilities/enum';
import { useDevicesState } from '../../utilities/useDevicesState';
import Modal from 'react-bootstrap/Modal';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import StringHelpers from '../../utilities/stringHelpers';
import roleUtilities from '../../utilities/roleUtilities';
import arrayUtilities from '../../utilities/arrayUtilities';
import { Notifications } from '../notifications/notifications';
import { endOfDay, startOfDay, subtractDays, toDateTimeString } from '../../utilities/dateUtilities';
import { InfoWidget } from '../shared/infoWidget';
import { useBreachStatusCounts } from '../../utilities/useBreachStatusCounts';
import { ErrorModal } from '../../utilities/errorModal';
import { DeviceStatusWidget } from './deviceStatusWidget';
import { appealRagBands, appealRagBandLabels } from '../../utilities/appealRagStatus';
import { StatusBar } from '../shared/statusBar';
import {SuccessModal} from '../shared/successModal';
import {WarningModal} from '../shared/warningModal';
import stringHelpers from "../../utilities/stringHelpers";
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterPill, renderTagFilterItemLabel } from '../shared/appliedFilterPill';
import appliedFiltersUtilities from '../../utilities/appliedFiltersUtilities';
import { DashboardFiltersModal } from './dashboardFiltersModal';

function Dashboard(props) {
    const [breaches, setBreaches] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [paidPcns, setPaidPcns] = useState(null)
    const [loadingPcns, setLoadingPcns] = useState(false)
    const [siteId, setSiteId] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);

    const [type, setType] = useState(null);
    const [status, setStatus] = useState(0);
    const [search, setSearch] = useState("");
    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);

    const [loading, setLoading] = useState(false);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const [multiVoidList, setMultiVoidList] = useState([]);
    const [showVoidModal, setShowVoidModal] = useState(false);
    const [note, setNote] = useState("");
    const [voidReasons, setVoidReasons] = useState(null)
    const [voidReason, setVoidReason] = useState("")
    const [voidErrorMessage, setVoidErrorMessage] = useState(null)
	const [voidSuccessMessage, setVoidSuccessMessage] = useState(null)
	const [voidWarningMessage, setVoidWarningMessage] = useState(null)
    const [canRedo, setCanRedo] = useState(false)
    const [notifications, setNotifications] = useState(null);
    const [showRedoModal, setShowRedoModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null)
    const [settings, setSettings] = useState(null);
    const [lettersStatistics, setLettersStatistics] = useState(null)
    const [isLoadingLetters, setIsLoadingLetters] = useState(false)
    const [lettersFromDate, setLettersFromDate] = useState(null)
    const [lettersRangeDays, setLettersRangeDays] = useState(1)
    const lettersRangeDebounceRef = useRef(null)
    const [appealRagCounts, setAppealRagCounts] = useState(null)
    const [isLoadingAppealRagCounts, setIsLoadingAppealRagCounts] = useState(false)
    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) || roleUtilities.isThirdPartyManager(props.user, props.organisationId)
    const showStatusFilter = !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId)

    const getOrganisationSettings = function () {
        Api.getOrganisationSettings(
            (data) => setSettings(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getBreaches = (query, siteId, filterStart, filterEnd, status, type, pageNumber, tagIds) => {
        setLoading(true)
        Api.getBreaches(
            (data) => {
                setBreaches(data);
                setLoading(false);
            },
            (error) => {console.log(error); setLoading(false)},
            query, !StringHelpers.isNullOrEmpty(siteId) ? [siteId] : null, null, null, filterStart, filterEnd, type, !showStatusFilter ? null : status === null ? null : [ status ], null, pageNumber, 0, null, null, null,
            null, null,
            tagIds,
            props.organisationId,
            props.token, null
        )
    };

    const getNotifications = () => {
        Api.getNotificationsByOrganisation(
            props.organisationId,
            data => setNotifications(data),
            error => console.log(error),
            props.token
        )
    }

    const getVoidReasons = () => {
        Api.getVoidReasons(
            (data) => setVoidReasons(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    }

    const clearFilters = function () {
        setStatus(0);
        setType(null);
        setFilterStart(null);
        setFilterEnd(null);
        setSiteId(null);
        setSelectedTags([]);
        setAppliedFilters(showStatusFilter ? { "Status": `${ Enum.BreachStatus[0] }` } : null);
        setShowFilterPills(true);
        setPageNumber(0);
        getBreaches(search, null, null, null, 0, null, 0, []);
    };

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Site":
                setSiteId(null)
                getBreaches(search, null, filterStart, filterEnd, status, type, 0, selectedTags)
                break
            case "Type":
                setType(null)
                getBreaches(search, siteId, filterStart, filterEnd, status, null, 0, selectedTags)
                break
            case "Status":
                setStatus(0)
                getBreaches(search, siteId, filterStart, filterEnd, 0, type, 0, selectedTags)
                break
            case "From":
                setFilterStart(null)
                getBreaches(search, siteId, null, filterEnd, status, type, 0, selectedTags)
                break
            case "To":
                setFilterEnd(null)
                getBreaches(search, siteId, filterStart, null, status, type, 0, selectedTags)
                break
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                getBreaches(search, siteId, null, null, status, type, 0, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                getBreaches(search, siteId, filterStart, filterEnd, status, type, 0, [])
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            }
            else if (closedLabel === "Status") {
                updatedFilters["Status"] = Enum.BreachStatus[0]
            }
            else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                getBreaches(search, siteId, filterStart, filterEnd, status, type, 0, remainingIds)
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const changePageNumber = function(num){
        setPageNumber(num);
        getBreaches(search, siteId, filterStart, filterEnd, status, type, num, selectedTags)
        window.scrollTo({ top: 0 });
    }

    const getLettersRawData = (startDate) => {
        setIsLoadingLetters(true)
        Api.getLettersRawData(
            printedData => {
                Api.getLettersRawData(
                    errorData => {
                        setLettersStatistics({
                            printed: printedData.totalCount,
                            error: errorData.totalCount,
                            totalCount: printedData.totalCount + errorData.totalCount,
                        });
                        setIsLoadingLetters(false)
                    },
                    (error) =>{
                        console.log(error)
                        setLettersStatistics(null)
                        setIsLoadingLetters(false)
                    },
                    null, startDate, new Date().toISOString(), 0, null, "Error", null,
                    props.organisationId, props.token
                )
            },
            error => {
                console.log(error)
                setIsLoadingLetters(false)
                setLettersStatistics(null)
            },
            null, startDate, new Date().toISOString(), 0, null, "Printed", null,
            props.organisationId, props.token
        )
    }

    const getPaidPcns = () => {
            setLoadingPcns(true)
            Api.getPcnsPaidReports(
                data => {
                    const amount = data.reduce((acc, curr) => acc += (curr.amount * curr.count), 0)
                    setPaidPcns(StringHelpers.formatDecimal(amount, 2, "£"))
                    setLoadingPcns(false)
                },
                error => { console.log(error); setLoadingPcns(false) },
                startOfDay(new Date()), new Date(), null, null, 0, null, null, 0, null, props.organisationId, props.token
            )
        }

    const getAppealRagCounts = () => {
        setIsLoadingAppealRagCounts(true)
        Promise.all(appealRagBands.map(band => new Promise((resolve, reject) => Api.getBreaches(
            data => resolve([band.key, data.totalCount]),
            reject,
            null, null, null, null, null, null, null, [200], null, 0, 0, null, null, null,
            band.minReceivedDaysAgo, band.maxReceivedDaysAgo, null,
            props.organisationId, props.token, new AbortController().signal
        ))))
            .then(counts => setAppealRagCounts(Object.fromEntries(counts)))
            .catch(error => { console.log(error); setAppealRagCounts(null) })
            .finally(() => setIsLoadingAppealRagCounts(false))
    }

    useEffect(() => {
        getBreaches(search, siteId, filterStart, filterEnd, status, type, 0, selectedTags)
        getNotifications();
        getPaidPcns()
        getOrganisationSettings()
        getVoidReasons()
        getLettersRawData(subtractDays(new Date(), 1))
        getAppealRagCounts()
        setAppliedFilters(showStatusFilter ? { "Status": `${ Enum.BreachStatus[status] }` } : null);
        setShowFilterPills(true);


        return () => clearTimeout(lettersRangeDebounceRef.current)
    }, []);

    const baseStyle = { height: "10px", margin: "0 12px", borderRadius: "9999px" };

    const {orderedCameras, kiosks, allCamerasUrl, allKiosksUrl, getCameras, getKiosks, camerasLoading, kiosksLoading} = useDevicesState(props.organisationId, props.token);

    const appealsTotal = appealRagCounts ? Object.values(appealRagCounts).reduce((acc, count) => acc + count, 0) : 0
    const {totalCount: tolCount, isLoading: loadingTol} = useBreachStatusCounts(210, props.organisationId, props.token)
    const {totalCount: debtRecoveryCount, isLoading: loadingDebtRecovery} = useBreachStatusCounts(400, props.organisationId, props.token)
    const {totalCount: processedCount, isLoading: loadingProcessed} = useBreachStatusCounts(100, props.organisationId, props.token, true, startOfDay(new Date()), new Date())
    const {totalCount: voidedCount, isLoading: loadingVoided} = useBreachStatusCounts(503, props.organisationId, props.token, true, startOfDay(new Date()), new Date())

    const handleCheckChange = (value) => {
        const updatedArray = arrayUtilities.toggle(value, multiVoidList)
        setMultiVoidList(updatedArray)
        setCanRedo(
            !arrayUtilities.isNullOrEmpty(updatedArray) && 
            breaches.items.filter(item => updatedArray.includes(item.id)).every(breach => breach.breachStatus === 0 && !breach.isCurrentlyOnHold)
        )
    }

    const handleMultiVoidConfirm = () => {
        setShowVoidModal(false);
        Api.voidMultipleTickets(
            data => {
                if (data.isError) {
					setVoidErrorMessage(data.errorMessage)
				}
                else {
                    if (data.length > 0) {
                        setVoidSuccessMessage(`${data.length } ${data.length > 1 ? "breaches" : "breach"} voided successfully`)
                    } else {
                        setVoidWarningMessage("No breaches were updated")
                    }
                    getBreaches(search, siteId, filterStart, filterEnd, status, type, pageNumber, selectedTags);
                    setMultiVoidList([]);
                    setVoidReason(null);
                    setNote("");
                }
            },
            error => {
                console.log(error)
				setVoidErrorMessage(error.errorMessage)
            },
            multiVoidList, !StringHelpers.isNullOrEmpty(voidReason) ? voidReason : null, !StringHelpers.isNullOrEmpty(note) ? note : "ticket voided", props.organisationId, props.token)
    }

    const handleRemoveAndRedo = () => {
        setLoading(true)
        setShowRedoModal(false)
        Api.deleteBreaches(
            props.organisationId, multiVoidList,
            data => {
                if (data.isError) {
                    setLoading(false)
                    setErrorMessage(data.errorMessage)
                }
                else {
                    setLoading(false)
                    setShowRedoModal(false)
                    setErrorMessage(null)
                    setCanRedo(false)
                    getBreaches(search, siteId, filterStart, filterEnd, status, type, pageNumber, selectedTags);
                    setMultiVoidList([]);
                }
            },
            error => {
                setLoading(false)
                setErrorMessage(error.message)
            },
            props.token
        )
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    { notifications && <Notifications notifications={notifications} /> }
                    <div className='row mb-3 mt-3'>
                        {
                            roleUtilities.isOrganisationAdmin(props.user, props.organisationId) && !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                            <div className='col-12 col-sm-6 col-md-4 col-lg mb-3'>
                                <InfoWidget
                                    title="Today's paid PCN revenue"
                                    cta={{
                                        label: "See all",
                                        pathname: `/organisation/${ props.organisationId }/reports/pcns-paid`
                                    }}
                                    icon={{class: "fas fa-coins", colour: "success"}}
                                    content={ paidPcns }
                                    isLoading={ loadingPcns }
                                    key="paid-pcns-widget"
                                />
                            </div>
                        }
                        <div className='col-12 col-sm-6 col-md-4 col-lg mb-3'>
                            <InfoWidget
                                title="Appeals received"
                                content={null}
                                cta={{
                                    label: "See all",
                                    pathname: `/organisation/${ props.organisationId }/enforcement`,
                                    forwardingProps: { status: 200 }
                                }}
                                icon={{ class: "fas fa-question-circle", colour: "warning" }}
                                isLoading={isLoadingAppealRagCounts}
                                handleRefreshClick={() => getAppealRagCounts()}
                                key="appeals-received-widget"
                            >
                                { appealRagCounts && <StatusBar counts={appealRagCounts} labels={appealRagBandLabels} barPrefix={<div className="fs-3 mr-3">{StringHelpers.formatDecimal(appealsTotal, 0)}</div>} barMargin="0" legendClassName="px-0" /> }
                            </InfoWidget>
                        </div>
                        <div className='col-12 col-sm-6 col-md-4 col-lg mb-3'>
                            <InfoWidget
                                title="Transfer of Liabilities received"
                                content={tolCount}
                                cta={{
                                    label: "See all",
                                    pathname: `/organisation/${ props.organisationId }/enforcement`,
                                    forwardingProps: { status: 210 }
                                }}
                                icon={{ class: "fas fa-exchange-alt", colour: "default" }}
                                isLoading={loadingTol}
                                key="tol-widget"
                            />
                        </div>
                        { !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&
                        <div className='col-12 col-sm-6 col-md-4 col-lg mb-3'>
                            <InfoWidget
                                title="Ready for Debt Recovery"
                                content={debtRecoveryCount}
                                cta={{
                                    label: "See all",
                                    pathname: `/organisation/${ props.organisationId }/enforcement`,
                                    forwardingProps: { status: 400 }
                                }}
                                icon={{ class: "fas fa-file-invoice", colour: "danger" }}
                                isLoading={loadingDebtRecovery}
                                key="debt-recovery-widget"
                            />
                        </div>}
                        {!isThirdPartyUser &&
                        <div className='col-12 col-sm-6 col-md-4 col-lg mb-3'>
                            <InfoWidget
                                title="Processed today"
                                content={processedCount}
                                cta={{
                                    label: "See all",
                                    pathname: `/organisation/${ props.organisationId }/reports/pcns-issued`,
                                    forwardingProps: { fromDate: startOfDay(new Date()), toDate: endOfDay(new Date())}
                                }}
                                icon={{ class: "fas fa-clipboard-list", colour: "primary" }}
                                isLoading={loadingProcessed}
                                key="processed-widget"
                            />
                        </div>}
                        {!isThirdPartyUser && <div className='col-12 col-sm-6 col-md-4 col-lg mb-3'>
                            <InfoWidget
                                title="Voided today"
                                content={voidedCount}
                                cta={{
                                    label: "See all",
                                    pathname: `/organisation/${ props.organisationId }/reports/voids`,
                                    forwardingProps: { fromDate: startOfDay(new Date()), toDate: endOfDay(new Date()) }
                                }}
                                icon={{ class: "far fa-times-circle", colour: "danger" }}
                                isLoading={loadingVoided}
                                key="voided-widget"
                            />
                        </div>}
                    </div>
                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&
                    <div className="dashboard-status-container">
                        <DeviceStatusWidget
                            handleRefreshClick={() => getCameras()}
                            viewAllUrl={allCamerasUrl}
                            orderedDevices={orderedCameras}
                            isLoading={camerasLoading}
                            deviceType={Enum.DeviceType[0]}
                            dangerThreshold={settings?.cameraStatusDangerThreshold}
                            warningThreshold={settings?.cameraStatusWarningThreshold}
                            key={Enum.DeviceType[0]}
                        />
                        <DeviceStatusWidget
                            handleRefreshClick={() => getKiosks()}
                            viewAllUrl={allKiosksUrl}
                            orderedDevices={kiosks}
                            isLoading={kiosksLoading}
                            deviceType={Enum.DeviceType[1]}
                            settings={settings}
                            key={Enum.DeviceType[1]}
                            dangerThreshold={settings?.kioskStatusDangerThreshold}
                            warningThreshold={settings?.kioskStatusWarningThreshold}
                        />
                            <div className="card status-widget">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between px-2">
                                        <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Letters</h5>
                                        <div className="d-flex align-items-center">
                                            <div className="d-flex align-items-center mr-2">
                                                <small className="m-0 nowrap mr-1">Last {lettersRangeDays} {stringHelpers.pluralSuffixModifier(lettersRangeDays, "days")}</small>
                                                <input className="form-control-range" id="formControlRange"
                                                       type="range" step="1" min="1" max="7" list="markers" value={lettersRangeDays}
                                                       onChange={e => {
                                                           const days = Number(e.target.value)
                                                           setLettersRangeDays(days)
                                                           const fromDate = subtractDays(new Date(), days)
                                                           setLettersFromDate(fromDate)
                                                           clearTimeout(lettersRangeDebounceRef.current)
                                                           lettersRangeDebounceRef.current = setTimeout(() => {
                                                               getLettersRawData(fromDate)
                                                           }, 500)
                                                       }}/>
                                                <datalist id="markers">
                                                    { Array.from({ length: 7 }, (_, index) => (
                                                        <option key={index} value={index + 1} label={String(index + 1)}></option>
                                                    )) }
                                                </datalist>
                                            </div>
                                            <button
                                                onClick={()=>getLettersRawData(lettersFromDate)}
                                                className="btn btn-none p-0 m-0"
                                            >
                                                <i className="fas fa-sync d-flex align-items-center"></i>
                                            </button>
                                            <Link to={`organisation/${props.organisationId}/raw-data/letters`}>
                                                <button
                                                    className="btn btn-falcon-default btn-sm ml-2 d-flex align-items-center">
                                                    <span>View All<i className="ml-2 fas fa-chevron-right"></i></span>
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className='stacked-chart'>
                                {
                                        isLoadingLetters
                                            ? <span className='tiny-loader'><Loader /></span>
                                                : lettersStatistics === null
                                                ? <div className='d-flex justify-content-center'><i className='fas fa-question fa-3x' style={ { color: "#c9c9c9" } }></i></div>
                                                    :<>
                                                    <div style={(()=>{
                                                        const total=lettersStatistics.totalCount
                                                        if(total===0) return {
                                                            ...baseStyle,
                                                            background:"#e9ecef"
                                                        };
                                                        const printedPct=(lettersStatistics.printed/lettersStatistics.totalCount)*100;
                                                        const errorPct=(lettersStatistics.error/lettersStatistics.totalCount)*100;
                                                        const stopsString=`#00d27a 0 ${printedPct}%, #e63757 ${printedPct}% ${printedPct+errorPct}%`
                                                        return {
                                                            ...baseStyle,
                                                            background:`linear-gradient(to right, ${stopsString})`
                                                        };
                                                    })()}>
                                                    </div>
                                                    <div className='d-flex px-3 mt-2'>
                                                        <div key="printed-legend"
                                                             className='d-flex align-items-center mr-3'>
                                                            <div style={{
                                                                width:"12px",
                                                                height:"12px",
                                                                borderRadius:"9999px",
                                                                background:"#00d27a",
                                                                flexShrink:0
                                                            }}/>
                                                            <p className='m-0 ml-1'>
                                                                {lettersStatistics.printed}
                                                            </p>
                                                        </div>
                                                        <div key="error-legend"
                                                             className='d-flex align-items-center mr-3'>
                                                            <div style={{
                                                                width:"12px",
                                                                height:"12px",
                                                                borderRadius:"9999px",
                                                                background:"#e63757",
                                                                flexShrink:0
                                                            }}/>
                                                            <p className='m-0 ml-1'>
                                                                {lettersStatistics.error}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </>}
                                </div>
                            </div>
                    </div>}
                    <div className="card mb-3 col-12">
                        <Modal show={showVoidModal && !arrayUtilities.isNullOrEmpty(voidReasons)} onHide={() => { setShowVoidModal(false); setVoidReason(null); setNote("") }}>
                            <Modal.Header>
                                <Modal.Title>
                                    Void multiple breaches.
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row mb-2">
                                    <div className="col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Reason:</p>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mb-0">
                                            <select
                                                id="void-reason-selector"
                                                className="border rounded py-1 px-2 w-100"
                                                onChange={ (e) => setVoidReason(e.target.value) }
                                                value={ voidReason }
                                            >
                                                <option value="">Select a reason</option>
                                                {voidReasons?.map(item => <option value={item.id}>{item.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Note:</p>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mb-0">
                                            <textarea className="form-control mb-0" rows={4} value={note} onChange={(e) => setNote(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    className="btn btn-sm btn-danger mt-1"
                                    onClick={() => { setShowVoidModal(false); setVoidReason(null); setNote("") }}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-sm btn-success mt-1"
                                    onClick={handleMultiVoidConfirm}
                                >
                                Confirm
                                </button>
                            </Modal.Footer>
                        </Modal>
                        <Modal show={showRedoModal} onHide={() => setShowRedoModal(false)}>
                            <Modal.Header>
                                <Modal.Title>
                                    Remove and re-do
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to remove and re-do {multiVoidList.length === 1 ? <>this ticket</> : <>these {multiVoidList.length} tickets</> }?
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    className="btn btn-sm btn-danger mt-1"
                                    onClick={() => setShowRedoModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-sm btn-success mt-1"
                                    onClick={handleRemoveAndRedo}
                                >
                                    Confirm
                                </button>
                            </Modal.Footer>
                        </Modal>
                        <div className="card-header d-flex align-items-center justify-content-between">                            
                            <h5 className="fs-0 m-0 text-nowrap">Breaches</h5>
                            <div className="d-flex">
                                <div className='d-flex align-items-center'>
                                    <div className='mr-2'>
                                        <SearchBarWithDebounce
                                            onSearchQueryChange={query => {
                                                setSearch(query)
                                                setPageNumber(0)
                                                getBreaches(query, siteId, filterStart, filterEnd, status, type, 0, selectedTags)
                                            }}
                                        />
                                    </div>
                                    <div className='mr-2'>
                                        <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                    </div>
                                </div>
                                <div className='d-flex ml-auto align-items-center'>
                                    {!roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                                    <button
                                        disabled={ !multiVoidList || multiVoidList.length === 0 }
                                        className="btn btn-danger btn-sm text-nowrap"
                                        onClick={ () => setShowVoidModal(true) }>
                                        <i className="fas fa-times"></i> Void
                                    </button>}
                                    {
                                        roleUtilities.isOrganisationAdmin(props.user, props.organisationId) && !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                                        <OverlayTrigger trigger="hover" placement='left' overlay={ <Popover className='redo-popover'><p className='m-0 p-2'>Remove the breach and reset the parking sessions so they can be re-processed in the next batch tomorrow morning</p></Popover> }>
                                            <div className='d-flex align-items-center'>
                                                <button
                                                    disabled={ !canRedo }
                                                    className="btn btn-primary btn-sm ml-2 text-nowrap"
                                                    onClick={ () => setShowRedoModal(true) }>
                                                    <i className="fas fa-undo"></i> Remove and re-do
                                                </button>
                                            </div>
                                        </OverlayTrigger>
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            showFilterPills && appliedFilters &&
                            <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                {
                                    Object.entries(appliedFilters).map(
                                        ([label, value]) => <AppliedFilterPill
                                            key={ label }
                                            label={ label }
                                            value={ value }
                                            isResettable={ label === "Status" }
                                            renderItemLabel={ renderTagFilterItemLabel }
                                            onTextClick={ () => setShowFiltersModal(true) }
                                            onCloseClick={ handleFilterPillClose }
                                            onRemoveItem={ handleFilterPillItemRemove }
                                        />
                                    )
                                }
                                {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Reset all filters</button>}
                            </div>
                        }
                        <div className="card-body bg-light border-top details-container p-0">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>VRM</th>
                                        <th>Site</th>
                                        <th>Contravention</th>
                                        <th className="text-center">Contravention Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? <><tr>
                                        <td colSpan={6}>
                                            <Loader />
                                        </td></tr></>
                                    : <>
                                        {props.sites && breaches && breaches !== null && !arrayUtilities.isNullOrEmpty(breaches.items) && breaches.items.map((breach, i) => {
                                            var breachUrl = `/organisation/${props.organisationId}/breach/${breach.id}`;
                                            let breachSite = props.sites.find(site => site.id === breach.siteId);
            
                                            var siteDetailsUrl = breachSite ? `/organisation/${props.organisationId}/client/${breachSite.clientId}/site/${breach.siteId}` : "";

                                            return (
                                                <tr key={breach.id}>
                                                    <td>
                                                        <input
                                                            onChange={e => handleCheckChange(e.target.value)}
                                                            value={breach.id}
                                                            type="checkbox"
                                                            id={breach.id}
                                                            name={breach.vrm}
                                                        />
                                                    </td>
                                                    <td><Link to={breachUrl} className="number-plate-link"><h6 className="mb-0 small-number-plate">
                                                        {breach.vrm}</h6></Link></td>
                                                    {StringHelpers.isNullOrEmpty(siteDetailsUrl) ? 
                                                        <td><h6>{breach.siteName}</h6></td> :  <td><Link to={siteDetailsUrl}><h6>{breach.siteName}</h6></Link></td>
                                                    }
                                                    <td>{breach.contraventionName}</td>
                                                    <td className="text-center">{ toDateTimeString(breach.timestamp) }</td>
                                                    <td>{Enums.BreachStatus[breach.breachStatus]}</td>
                                                </tr>
                                            )
                                        })}
                                    </>}
                                </tbody>
                            </table>
                        </div>
                        <div className="card-footer border-top ">
                            <div className="d-flex justify-content-center row ">
                                <div className="col-auto ">
                                    <Pagination totalResults={breaches?.totalCount} currentPage={pageNumber} changePageNumber={changePageNumber} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!StringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal key="remove-redo-error" message={errorMessage} onHide={() => setErrorMessage(null)} />}
            {!StringHelpers.isNullOrEmpty(voidErrorMessage) && <ErrorModal key="void-error" message={voidErrorMessage} onHide={() => setVoidErrorMessage(null)} />}
            {!StringHelpers.isNullOrEmpty(voidSuccessMessage) && <SuccessModal message={voidSuccessMessage} onHide={() => setVoidSuccessMessage(null)} />}
            {!StringHelpers.isNullOrEmpty(voidWarningMessage) && <WarningModal message={voidWarningMessage} onHide={() => setVoidWarningMessage(null)} />}
            {
                showFiltersModal &&
                <DashboardFiltersModal
                    showModal={showFiltersModal}
                    handleClose={() => setShowFiltersModal(false)}
                    handleConfirm={(draftFilters) => {
                        setFilterStart(draftFilters.startDate)
                        setFilterEnd(draftFilters.endDate)
                        setType(draftFilters.type)
                        setStatus(draftFilters.status)
                        setSiteId(draftFilters.siteId)
                        setSelectedTags(draftFilters.selectedTags)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        setPageNumber(0)
                        getBreaches(search, draftFilters.siteId, draftFilters.startDate, draftFilters.endDate, draftFilters.status, draftFilters.type, 0, draftFilters.selectedTags)
                    }}
                    initialStartDate={filterStart}
                    initialEndDate={filterEnd}
                    initialType={type}
                    initialStatus={status}
                    initialSiteId={siteId}
                    initialSelectedTags={selectedTags}
                    initialAppliedFilters={appliedFilters}
                    showStatusFilter={showStatusFilter}
                    sites={props.sites}
                    tags={props.tags || []}
                    key="main-dashboard-filters-modal"

                />
            }
        </div>
    )
}

export default Dashboard;